import React from 'react';
import { MbmProvider } from '@amzn/react-arb-tools';
import arbManifest from 'translations/arbManifest';
import { getMbmOptions } from '../helpers';
import DealershipForm from "src/pages/DealershipForm";


const mbmOptions = getMbmOptions(arbManifest);

const App = () => {
    const currentPath = window.location.pathname;
    
    const renderPage = () => <DealershipForm />;
    
    return (
        <MbmProvider {...mbmOptions}>
            {renderPage()}
        </MbmProvider>
    );
};

export default App;
